/* eslint-env browser */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import MapContainer from './containers/MapContainer';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapkit: any;
    token: string;
    appLang: string;
  }
}

const rootElement = document.querySelector('.app-map-container');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);
root.render(
  <StrictMode>
    <MapContainer />
  </StrictMode>,
);
